import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

export const errorStyle: CSSObject = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  placeItems: "center",
};

export const errorHeadingStyle: CSSObject = {
  ...typographyStyles.heading3Obj,
  ...typographyStyles.fontFamily.circular,
  margin: "31px 0 15px",
  color: constants.colors.ui.neutral[600],
};

export const errorMessageStyle: CSSObject = {
  ...typographyStyles.textLObj,
  color: constants.colors.ui.neutral[600],
  marginBlock: 0,
};
